export const environment = {
  production: false,
  backendURL: 'https://myaccount-dev.app.karcher.com/api/v1',
  translation: 'https://myaccount-dev.app.karcher.com/translation',
  configuration: 'https://myaccount-dev.app.karcher.com',
  corporateUrl: 'https://cms-stage.app.kaercher.com',
  loginUrl: 'https://auth.dev.karcher.com',
  notFoundUrl: 'https://www.kaercher.com/int/404.html',
  clientId: 'mykaercher-web',
  clientSecret: 'codRLhHxmsNlIeRFSxwXOZYCW66EwDyUlOTgnnQA',
  rock: 'https://ak-rock-dev-srm-app.s3.eu-central-1.amazonaws.com/remoteEntry.js',
  rrm: 'https://dev-rrm-app.s3.eu-central-1.amazonaws.com/remoteEntry.js',
  analyticsUrl:
    'https://assets.adobedtm.com/a13643f4feff/095e7dd7396b/launch-0d2ababb54fa-staging.min.js',
  recaptcha: {
    siteKey: '6LddnxsrAAAAAK3AOh0Ld1rSr37O_scNd4UTxWvI',
  },
  newMyk:{
    "en-IE": "https://karcher.preview.website.dev.karcher.com/ie/en/customer-account",
    "de-AT": "https://karcher.preview.website.dev.karcher.com/at/de/customer-account",
    "en-US": "https://karcher.preview.website.dev.karcher.com/us/en/customer-account",
    "en-GB": "https://karcher.preview.website.dev.karcher.com/gb/en/customer-account",
    "tr-TR": "https://karcher.preview.website.dev.karcher.com/tr/tr/customer-account",
    "en-MY": "https://karcher.preview.website.dev.karcher.com/my/en/customer-account",
    "th-TH": "https://karcher.preview.website.dev.karcher.com/th/th/customer-account",
    "vi-VN": "https://karcher.preview.website.dev.karcher.com/vn/vi/customer-account",
    "ro-RO": "https://karcher.preview.website.dev.karcher.com/ro/ro/customer-account",
    "de-DE": "https://karcher.preview.website.dev.karcher.com/de/de/account",
    "nl-BE": "https://karcher.preview.website.dev.karcher.com/be/nl/account",
    "fr-BE": "https://karcher.preview.website.dev.karcher.com/be/fr/account",
    "el-GR": "https://karcher.preview.website.dev.karcher.com/gr/el/account",
    "en-NZ": "https://karcher.preview.website.dev.karcher.com/nz/en/account",
    "de-CH": "https://karcher.preview.website.dev.karcher.com/ch/de/account",
    "fr-CH": "https://karcher.preview.website.dev.karcher.com/ch/fr/account",
    "nl-NL": "https://karcher.preview.website.dev.karcher.com/nl/nl/account",
    "en-AU": "https://karcher.preview.website.dev.karcher.com/au/en/account",

    "lv-LV": "https://karcher.preview.website.dev.karcher.com/lv/lv/customer-account",
    "lt-LT": "https://karcher.preview.website.dev.karcher.com/lt/lt/account",
    "et-EE": "https://karcher.preview.website.dev.karcher.com/ee/et/kliendikonto"
  }
};
